const PERMISSIONS = {
  AUDIT: 'AUDIT',
  ORGANIZATION: 'ORGANIZATION',
  USER: 'USER',
  USER_PROFILE: 'USER_PROFILE',
  PATIENT: 'PATIENT',
  DEVICE: 'DEVICE',
  REPORT: 'REPORT',
  ORG_CONFIG: 'ORG_CONFIG',
  GATEWAY: 'GATEWAY',
  ACTIONS: {
    Add: 'Add',
    Edit: 'Edit',
    View: 'View',
    List: 'List',
    Delete: 'Delete',
    Search: 'Search',
    Invite: 'Invite',
    Assign: 'Assign',
    Export: 'Export',
  },
} as const;

export default PERMISSIONS;
